<template>
  <div class="lotti-lead-container">

    <div class="lotti-grid-row lotti-grid-row-small lotti-grid-reverse-order">

      <div class="lotti-grid-col lotti-grid-col-66">
        <therapist-management-module></therapist-management-module>
      </div>

      <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-mini">
        <div class="lotti-therapist-module">
          <div class="lotti-therapist-name">Dienst {{ auth.user.profile.serviceName }}</div>
          <div class="lotti-therapist-email">Leitung: {{ auth.user.profile.firstName }} {{ auth.user.profile.lastName }}</div>
        </div>
      </div>

      <div class="lotti-grid-col lotti-grid-col-33 lotti-grid-mini" style="padding-top: 4px;">
        <service-module></service-module>
      </div>

    </div>

    <div class="lotti-grid-row lotti-grid-row-small">

      <div class="lotti-grid-col lotti-grid-col-50">
        <stats-module :lead-view="true"></stats-module>
      </div>

      <div class="lotti-grid-col lotti-grid-col-50">
        <report-module :lead-view="true" ></report-module>
      </div>

    </div>

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-50">
        <my-children-module :lead-view="true"></my-children-module>
      </div>
      <div class="lotti-grid-col lotti-grid-col-50">
        <my-sessions-module :lead-view="true"></my-sessions-module>
      </div>
    </div>

  </div>
</template>

<script>
import auth from '../../auth.js';
import statsModule from '../modules/Stats';
import reportModule from '../modules/Report';
import myChildrenModule from '../modules/MyChildren';
import mySessionsModule from '../modules/MySessions';
import therapistManagementModule from '../modules/TherapistManagement'
import serviceModule from '../modules/Service'
import {router} from '../../main.js';

export default {
  data() {
    return {
      auth: auth,

    }
  },
  methods: {

  },
  mounted() {

  },
  components: {
    statsModule: statsModule,
    reportModule: reportModule,
    serviceModule: serviceModule,
    myChildrenModule: myChildrenModule,
    mySessionsModule: mySessionsModule,
    therapistManagementModule: therapistManagementModule,
  }
}

</script>